import Api from './Api';

class LinkApi extends Api {
  url = 'links';
}

const singleton = new LinkApi();
export default singleton;
